import { useCallback } from 'react';

import { Button } from 'common/components';

import { useI18n, usePopup } from 'common/hooks';

import { memoizedComponent } from 'utils/memoizeComponent';

import MassPaymentPopupComponent from './MassPaymentPopup.component';

export const MassPaymentButton = memoizedComponent(() => {
  const { show } = usePopup();
  const { translate } = useI18n();

  const onClick = useCallback(() => show(MassPaymentPopupComponent()), [show]);

  return (
    <Button outline small onClick={onClick}>
      {translate('mobile:wallet:mass-payments')}
    </Button>
  );
});
